import type { CasaLeonStaffAvatar, StaffPresencePayload } from '@casa-leon-vivo/contracts/casa-leon';

/** Prioridad: 1 manual_floor, 2 shift, 3 session � evita avatares duplicados. */
const PRESENCE_RANK: Record<StaffPresencePayload['presence'], number> = {
  manual_floor: 1,
  shift: 2,
  session: 3,
  off: 99,
};

export function staffPresenceRule(
  current: CasaLeonStaffAvatar[],
  incoming: StaffPresencePayload,
): CasaLeonStaffAvatar[] {
  if (incoming.presence === 'off') {
    return current.filter((s) => s.staffId !== incoming.staffId);
  }

  const existing = current.find((s) => s.staffId === incoming.staffId);
  const rank = PRESENCE_RANK[incoming.presence];
  if (existing) {
    const existingRank = PRESENCE_RANK[existing.presence as StaffPresencePayload['presence']] ?? 99;
    if (rank > existingRank) {
      return current;
    }
  }

  const avatar: CasaLeonStaffAvatar = {
    staffId: incoming.staffId,
    displayName: incoming.displayName,
    role: incoming.role,
    presence: incoming.presence,
    spriteKey: `staff_${incoming.role}`,
  };

  const without = current.filter((s) => s.staffId !== incoming.staffId);
  return [...without, avatar];
}
